<template>
    <div class="content">
        <div class="logocontainer text-center">
            <div class="title mb-5 primary--text">Willkommen in der ÖSKB-App!</div>
            <img width="300" src="../../assets/oeskb.png" >
            <div class="mt-5 grey--text text--darken-3">Bitte wähle eine Aktion<br>aus dem Menü rechts oben!</div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "home"
    }
</script>

<style scoped>
    .content { position: fixed; bottom: 0; top: 48px; right: 0;
        left: 0; overflow-y: auto; background-color: #f2f2f2}

    .logocontainer {     position: absolute; height: 460px; width: 300px;
                left: 50%;
                top: 50%;
                transform: translate(-50%, -50%);}
    .logo {     -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
                filter: grayscale(100%); opacity: 0.3;}

</style>